import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Input } from "@/components/ui/input";
import { Search, Eye } from "lucide-react";
import { supplierQuoteAPI, supplierAPI } from "@/lib/api";

export default function SupplierQuotesPage() {
  const [quotes, setQuotes] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const load = useCallback(() => {
    supplierQuoteAPI.list().then(r => setQuotes(r.data.items || r.data)).catch(() => {});
    supplierAPI.list({ limit: 500 }).then(r => setSuppliers(r.data.items || r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const getSupplierName = (sid) => {
    const s = suppliers.find(sup => sup.id === sid);
    return s ? s.company : "-";
  };

  const filtered = search
    ? quotes.filter(q => q.original_filename?.toLowerCase().includes(search.toLowerCase()) || getSupplierName(q.supplier_id).toLowerCase().includes(search.toLowerCase()))
    : quotes;

  return (
    <div className="page-container" data-testid="supplier-quotes-page">
      <div className="mb-8">
        <h1 className="text-4xl font-bold tracking-tight text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Devis fournisseurs (PDF)
        </h1>
        <p className="text-slate-500 mt-1">Tous les devis fournisseurs scannes par IA</p>
      </div>
      <Card className="p-6 border border-slate-200 rounded-lg bg-white">
        <div className="relative w-full sm:w-72 mb-4">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input placeholder="Rechercher fichier, fournisseur..." value={search} onChange={e => setSearch(e.target.value)} className="pl-9" data-testid="supplier-quote-search" />
        </div>
        <div className="responsive-table">
          <Table>
            <TableHeader>
              <TableRow className="bg-slate-50">
                <TableHead className="uppercase text-xs text-slate-500">Fichier</TableHead>
                <TableHead className="uppercase text-xs text-slate-500">Fournisseur</TableHead>
                <TableHead className="uppercase text-xs text-slate-500">Date de scan</TableHead>
                <TableHead className="uppercase text-xs text-slate-500">Articles extraits</TableHead>
                <TableHead className="uppercase text-xs text-slate-500 w-20">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {filtered.map(q => (
                <TableRow key={q.id} className="table-row-hover">
                  <TableCell className="font-medium">{q.original_filename || "-"}</TableCell>
                  <TableCell>{getSupplierName(q.supplier_id)}</TableCell>
                  <TableCell>{q.created_at ? new Date(q.created_at).toLocaleDateString("fr-FR") : "-"}</TableCell>
                  <TableCell>{q.extracted_data?.items?.length || 0} article(s)</TableCell>
                  <TableCell>
                    {q.supplier_id && (
                      <Button variant="outline" size="sm" className="h-7 px-2 text-xs" onClick={() => navigate(`/fournisseurs/${q.supplier_id}`)} data-testid={`view-supplier-quote-${q.id}`}>
                        <Eye size={12} className="mr-1" />Voir
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
              {filtered.length === 0 && (
                <TableRow><TableCell colSpan={5} className="text-center text-slate-400 py-8">Aucun devis fournisseur scanne</TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </Card>
    </div>
  );
}
